import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { safObjectHelper } from '../../../../../utils/SafObjectHelper.ts';
import { companyApi } from '../../../../../modules';

interface IProps {
  ref?: any;
  formCode?: string;
  section?: any;
  data: any;
}

const View = (props: IProps) => {
  const [companyName, setCompanyName] = useState<any>();
  useEffect(() => {
    if (!props.data?.companyId) return;
    companyApi.getCompanyDetail({ companyId: props.data.companyId }).then((res) => {
      setCompanyName(res.resultObject.companyName);
    });
  }, [props.data?.companyId]);
  return (
    <div>
      <div className={'preview-row'}>
        <div
          className={'preview-col preview-label saf-bg-white'}
          style={{ color: 'red', fontSize: '0.5em', marginTop: '.2rem', marginBottom: '.2rem' }}
        >
          Please tick (√) where applicable
        </div>
      </div>
      <table
        className={'preview-table preview-white-table  preview-top-border preview-bottom-border'}
      >
        <colgroup>
          <col width={'25%'} />
          <col width={'75%'} />
        </colgroup>
        <tbody>
          <tr>
            <th rowSpan={2} style={{ height: '2.5rem', alignContent: 'center' }}>
              <input type={'checkbox'} className={'preview-checkbox large'} />
            </th>
            <th
              style={{
                backgroundColor: '#F3E7C2',
                paddingTop: '.4rem',
                paddingBottom: '.4rem',
                fontWeight: 'bold'
              }}
            >
              <b>GENERAL LIFTING</b>
            </th>
          </tr>
          <tr>
            <td style={{ whiteSpace: 'wrap', paddingTop: '.4rem', paddingBottom: '.4rem' }}>
              · Load weight less ≤ 10 MT and &lt; 50% of crane capacity chart at intended crane
              working radius <br />· Single Crane use
            </td>
          </tr>
          <tr>
            <th rowSpan={2} style={{ height: '2.5rem', alignContent: 'center' }}>
              <input type={'checkbox'} className={'preview-checkbox large'} />
            </th>
            <th
              style={{
                backgroundColor: '#FCE4D6',
                paddingTop: '.4rem',
                paddingBottom: '.4rem',
                fontWeight: 'bold'
              }}
            >
              <b>HEAVY LIFTING</b>
            </th>
          </tr>
          <tr>
            <td style={{ whiteSpace: 'wrap', paddingTop: '.4rem', paddingBottom: '.4rem' }}>
              · Load weight is more 10&gt;x&lt;25MT and 50%&lt;x&lt;75% of crane capacity chart at
              intended working radius <br />· Single Crane Use
            </td>
          </tr>
          <tr>
            <th
              rowSpan={2}
              style={{ height: '2.5rem', alignContent: 'center' }}
              className={'saf-border-bottom-none'}
            >
              <input type={'checkbox'} className={'preview-checkbox large'} />
            </th>
            <th
              style={{
                backgroundColor: '#FCB1A2',
                paddingTop: '.4rem',
                paddingBottom: '.4rem',
                fontWeight: 'bold'
              }}
            >
              <b>CRITICAL LIFTING</b>
            </th>
          </tr>
          <tr>
            <th
              style={{
                paddingTop: '.4rem',
                paddingBottom: '.4rem'
              }}
            >
              <table style={{ width: '100%' }} className={'preview-table-no-border'}>
                <tbody>
                  <tr>
                    <td>
                      <b>Total load &gt; 25 TON</b>
                    </td>
                    <td>
                      <b>Over or in live areas</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Total load &gt; 75% of the load chart </td>
                    <td>Tandem lifting (tailing lift) </td>
                  </tr>
                  <tr>
                    <td>Continuation of a lifting </td>
                    <td>Lifting of personnel </td>
                  </tr>
                </tbody>
              </table>
            </th>
          </tr>
        </tbody>
      </table>

      <div
        className={'preview-row preview-bottom-border preview-top-border'}
        style={{ marginTop: '.6rem' }}
      >
        <div className={'preview-col preview-label saf-bg-white'}>Type and Machinery No. : </div>
        <div className={'preview-col preview-value'}></div>
      </div>
    </div>
  );
};

export default View;
